import ModalContent from 'LuxKit/Modal/ModalContent'
import styled from 'styled-components'
import React from 'react'

const NoPaddingModalContent = styled(ModalContent)`
  padding: 0;
`

interface Props {
  disablePadding?: boolean;
  children: React.ReactNode;
}

function NavBarHamburgerMenuModalContent({ disablePadding, children }: Props) {
  const Content = !disablePadding ? ModalContent : NoPaddingModalContent
  return <Content flush>{children}</Content>
}

export default NavBarHamburgerMenuModalContent
